import { Center, Divider } from '@chakra-ui/react'

export default function StatDivider() {
    return (
        <Center mx="2">
            <Divider orientation="vertical" />
        </Center>
    )
}
